enum AlertType {
  WARNING = 'W',
  INFORMATION = 'I',
  CLOSURE = 'C'
}

enum AlertModel {
  AreaAlert = 'AreaAlert',
  TrailAlert = 'TrailAlert'
}

enum ObjectType {
  Area = 'area',
  Trail = 'trail'
}

enum AlertLabel {
  ADVISORY = 'Advisory',
  CLOSURE = 'Closure',
  INFORMATION = 'Informational'
}

type AlertId = number;
type Alert = {
  id?: AlertId;
  type?: AlertModel;
  objectId?: number;
  alertType: AlertType;
  status?: string;
  content: string;
  startDate: string | null;
  endDate: string | null;
  shortName: string;
  recursAnnually: boolean;
};

type AlgoliaAlert = {
  ID: AlertId;
  object_type: ObjectType;
  object_id: number;
  name: string;
  alert_type: AlertType;
  status: string;
  start_date?: number;
  end_date?: number;
};

export { AlertId, AlertType, AlertModel, ObjectType, AlertLabel, Alert, AlgoliaAlert };
